module.exports = __webpack_public_path__ + "static/media/pdf.2b60a250.svg";